<app-menu-common url="sales"></app-menu-common>

<div class="reglement-page">

  <div class="toolbar-card">

    <div class="toolbar-title">
      <mat-icon class="toolbar-icon">point_of_sale</mat-icon>
      <span>Règlements</span>
    </div>

    <div class="filter-item">
      <span class="filter-label">Sur</span>
      <mat-button-toggle-group class="span-toggle" hideSingleSelectionIndicator [value]="periodMode" (change)="setPeriodMode($event.value)" aria-label="Journée ou période">
        <mat-button-toggle [value]="false" id="rgl-span-day">Journée</mat-button-toggle>
        <mat-button-toggle [value]="true" id="rgl-span-period">Période</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    @if (!periodMode) {
      <div class="filter-item date-filter">
        <app-select-date label="Jour" [date]="date" (dateChange)="dateChange($event)"></app-select-date>
      </div>
    } @else {
      <div class="filter-item date-filter" id="rgl-from">
        <app-select-date label="Du" [date]="date" (dateChange)="dateChange($event)"></app-select-date>
      </div>
      <div class="filter-item date-filter" id="rgl-to">
        <app-select-date label="Au" [date]="dateTo" (dateChange)="dateToChange($event)"></app-select-date>
      </div>
    }

    <div class="filter-item">
      <label class="filter-label" for="rgl-store">Magasin</label>
      <select id="rgl-store" class="custom-select store-select" [ngModel]="store" (ngModelChange)="setStore($event)">
        <option [ngValue]="null">Tous</option>
        @for (s of stores; track s.id) {
          <option [ngValue]="s.id">{{ s.name }}</option>
        }
      </select>
    </div>

    <div class="filter-item">
      <label class="filter-label" for="rgl-station">Poste</label>
      <select id="rgl-station" class="custom-select station-select" [ngModel]="station" (ngModelChange)="setStation($event)">
        <option [ngValue]="null">Tous</option>
        @for (s of stationOptions; track s.id) {
          <option [ngValue]="s.id">{{ stationLabel(s) }}</option>
        }
      </select>
    </div>

    <div class="filter-item">
      <label class="filter-label" for="rgl-method">Mode de règlement</label>
      <select id="rgl-method" class="custom-select method-select" [compareWith]="sameIds" [ngModel]="method" (ngModelChange)="setMethod($event)">
        <option [ngValue]="null">Tous</option>
        @for (m of methodOptions; track m.ids[0]) {
          <option [ngValue]="m.ids">{{ m.name }}</option>
        }
      </select>
    </div>

    <div class="filter-item">
      <span class="filter-label" id="rgl-channel-label">Canal</span>
      <div class="channel-boxes" role="group" aria-labelledby="rgl-channel-label"
        matTooltip="Les règlements repris de l'ancien logiciel sont toujours affichés">
        @for (c of channelFilters; track c) {
          <mat-checkbox [id]="'rgl-channel-' + c" [checked]="hasChannel(c)" (change)="toggleChannel(c, $event.checked)">{{ channelLabels[c] }}</mat-checkbox>
        }
      </div>
    </div>

    <div class="toolbar-actions">
      @if (canTransfer) {
        <button mat-flat-button type="button" class="btn-transfer" id="newcashtransferbutton" (click)="openTransfer()"
          matTooltip="Mouvement d'espèces entre deux postes, ou dépôt en banque">
          <mat-icon>swap_horiz</mat-icon>
          Nouveau mouvement
        </button>
      }
      @if (canDeposit) {
        <button mat-flat-button type="button" class="btn-transfer" id="bankdepositbutton" (click)="openDeposit()"
          matTooltip="Déposer en banque les espèces d'un coffre-fort">
          <mat-icon>account_balance</mat-icon>
          Dépôt en banque
        </button>
      }
      <button mat-stroked-button type="button" class="btn-inline btn-ghost" aria-label="Actualiser" title="Recharger" (click)="load()">
        <mat-icon [class.spinning]="loading">refresh</mat-icon>
      </button>
    </div>

  </div>

  <div class="top-row">

    <div class="side-col">
      <!-- Totaux par mode : tous les règlements du jour ou de la période, même au-delà des lignes listées -->
      <div class="table-card totals-card">
        <div class="table-header-bar">
          <div class="table-title">
            <mat-icon>functions</mat-icon>
            <span>Totaux par mode</span>
          </div>
          @if (windowLabel) {
            <span class="window" matTooltip="Jour métier : de la bascule de caisse à la suivante">{{ windowLabel }}</span>
          }
        </div>
        @if (paymentsError) {
          <div class="load-error"><mat-icon>error_outline</mat-icon><span>Règlements illisibles : {{ paymentsError }}</span></div>
        }
        @if (day) {
          <table class="grid">
            <thead>
              <tr><th>Mode</th><th class="num">Nombre</th><th class="num">Montant</th></tr>
            </thead>
            <tbody>
              @for (t of totals; track t.method) {
                <tr>
                  <td>{{ t.name ?? ('Mode ' + t.method) }}</td>
                  <td class="num">{{ t.count }}</td>
                  <td class="num" [class.neg]="t.amount < 0">{{ t.amount | fc }} €</td>
                </tr>
              } @empty {
                <tr><td colspan="3" class="empty">Aucun règlement {{ multiDay ? 'sur la période' : 'ce jour' }}</td></tr>
              }
            </tbody>
            <tfoot>
              <tr><td>Total</td><td class="num">{{ day.count }}</td><td class="num" [class.neg]="day.total < 0">{{ day.total | fc }} €</td></tr>
            </tfoot>
          </table>
        }
      </div>

      <!-- Coffres-forts du magasin filtré (tous si « Tous ») : solde théorique à l'instant de la lecture -->
      <div class="table-card safes-card">
        <div class="table-header-bar">
          <div class="table-title">
            <mat-icon>lock</mat-icon>
            <span>Coffres-forts</span>
            <mat-icon class="hint-icon" matTooltip="Solde théorique : un coffre part de son dernier inventaire (de 0 sans inventaire), puis seuls les mouvements enregistrés le font varier. Il est calculé à l'instant de la lecture, quel que soit le jour affiché.">info_outline</mat-icon>
          </div>
        </div>
        @if (safesError) {
          <div class="load-error"><mat-icon>error_outline</mat-icon><span>Coffres-forts illisibles : {{ safesError }}</span></div>
        }
        @if (safes) {
          <table class="grid safes">
            <thead>
              <tr>
                <th>Coffre</th>
                <th class="num">Solde</th>
                <th>Dernier mouvement</th>
                @if (canDeposit) { <th class="c-action"></th> }
              </tr>
            </thead>
            <tbody>
              @for (s of safes; track s.station) {
                <tr>
                  <td class="wrap">{{ s.station_name ?? ('Poste ' + s.station) }} <span class="sub">{{ s.store_name ?? ('Magasin ' + s.store) }}</span>
                    @if (s.last_count_at) { <span class="sub last-count">{{ lastCountLabel(s) }}</span> }
                  </td>
                  @if (safesVisible && s.balance !== null) {
                    <td class="num" [class.neg]="s.balance < 0">{{ s.balance | fc }} €</td>
                  } @else {
                    <td class="num reserved" [matTooltip]="reservedHint">Réservé</td>
                  }
                  <td class="c-stamp">
                    @if (s.last_transfer_at) { {{ stamp(s.last_transfer_at) }} } @else { <span class="none">aucun</span> }
                  </td>
                  @if (canDeposit) {
                    <td class="c-action">
                      <div class="row-actions">
                        <button mat-icon-button type="button" class="btn-row btn-deposit-safe" [attr.aria-label]="'Déposer en banque depuis ' + (s.station_name ?? 'le coffre')"
                          matTooltip="Déposer en banque depuis ce coffre" (click)="openDeposit(s)">
                          <mat-icon>account_balance</mat-icon>
                        </button>
                        @if (canRefill) {
                          <button mat-icon-button type="button" class="btn-row btn-refill-safe" [attr.aria-label]="'Approvisionner une caisse depuis ' + (s.station_name ?? 'le coffre')"
                            matTooltip="Approvisionner une caisse du magasin depuis ce coffre (monnaie du matin)" (click)="openRefill(s)">
                            <mat-icon>point_of_sale</mat-icon>
                          </button>
                        }
                        @if (canCountStrongbox) {
                          <button mat-icon-button type="button" class="btn-row btn-count-strongbox" [attr.aria-label]="'Inventaire de ' + (s.station_name ?? 'ce coffre')"
                            matTooltip="Inventaire : compter les espèces de ce coffre, le compté devient le point de départ de son solde" (click)="openStrongboxCount(s)">
                            <mat-icon>inventory_2</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  }
                </tr>
              } @empty {
                <tr><td [attr.colspan]="canDeposit ? 4 : 3" class="empty">Aucun coffre-fort actif</td></tr>
              }
            </tbody>
            @if (safes.length > 1 && safesVisible) {
              <tfoot>
                <tr><td>Total</td><td class="num" [class.neg]="safesTotal < 0">{{ safesTotal | fc }} €</td><td></td>@if (canDeposit) { <td></td> }</tr>
              </tfoot>
            }
          </table>
        }
      </div>
    </div>

    <div class="main-col">
    <!-- Mouvements d'espèces du jour (tiroir → coffre, coffre → banque) -->
    <div class="table-card transfers-card">
      <div class="table-header-bar">
        <div class="table-title">
          <mat-icon>savings</mat-icon>
          <span>Mouvements d'espèces {{ multiDay ? 'de la période' : 'du jour' }}</span>
          @if (transfers) {
            <span class="badge-count">{{ transfers.transfers.length }}</span>
          }
        </div>
        <div class="card-actions">
          <button mat-stroked-button type="button" class="btn-card" id="exporttransfersbutton" (click)="exportTransfers()"
            [disabled]="!transfers?.transfers?.length" matTooltip="Mouvements affichés en fichier .csv (Excel)">
            <mat-icon>download</mat-icon>
            Exporter
          </button>
          <button mat-stroked-button type="button" class="btn-card" id="printtransfersbutton" (click)="printTransfers()"
            [disabled]="!transfers?.transfers?.length" matTooltip="Mouvements affichés, mis en page par le serveur pour l'impression">
            <mat-icon>print</mat-icon>
            Imprimer
          </button>
        </div>
      </div>
      @if (transfersError) {
        <div class="load-error"><mat-icon>error_outline</mat-icon><span>Mouvements illisibles : {{ transfersError }}</span></div>
      }
      @if (transfers) {
        <table class="grid transfers">
          <thead>
            <tr>
              <th class="c-hour">Heure</th>
              <th>De</th>
              <th>Vers</th>
              <th class="num">Montant</th>
              <th class="num">Solde source après</th>
              <th class="num">Solde destination après</th>
              <th>Auteur</th>
            </tr>
          </thead>
          <tbody>
            @for (t of transfers.transfers; track t.id) {
              <tr>
                <td class="c-hour">{{ hour(t.dat) }}</td>
                <td class="wrap">{{ t.source_name ?? ('Poste ' + t.source) }}</td>
                <td class="wrap">
                  @if (t.partner !== null) {
                    <button mat-icon-button type="button" class="btn-print-deposit" (click)="printDeposit(t.id)"
                      matTooltip="Dépôt en banque : réimprimer son bordereau de versement" [attr.aria-label]="'Bordereau de versement n° ' + t.id">
                      <mat-icon>print</mat-icon>
                    </button>{{ t.partner_name ?? ('Banque ' + t.partner) }}
                  } @else {
                    {{ t.destination_name ?? ('Poste ' + t.destination) }}
                  }
                </td>
                <td class="num" [class.neg]="t.amount < 0">{{ t.amount | fc }} €</td>
                @if (t.source_balance !== null) {
                  <td class="num" [class.neg]="t.source_balance < 0">{{ t.source_balance | fc }} €</td>
                } @else {
                  <td class="num reserved" [matTooltip]="reservedHint">—</td>
                }
                @if (t.destination_balance !== null) {
                  <td class="num" [class.neg]="t.destination_balance < 0">{{ t.destination_balance | fc }} €</td>
                } @else if (t.destination !== null) {
                  <td class="num reserved" [matTooltip]="reservedHint">—</td>
                } @else {
                  <td class="num"></td>
                }
                <td class="wrap">{{ t.user_name }}</td>
              </tr>
            } @empty {
              <tr><td colspan="7" class="empty">Aucun mouvement d'espèces {{ multiDay ? 'sur la période' : 'ce jour' }}</td></tr>
            }
          </tbody>
        </table>
      }
    </div>

    <!-- Remises de chèques de la période : n° = id de l'event qui l'a créée ; nombre et total de toute la remise -->
    <div class="table-card remittances-card">
      <div class="table-header-bar">
        <div class="table-title">
          <mat-icon>receipt_long</mat-icon>
          <span>Remises de chèques {{ multiDay ? 'de la période' : 'du jour' }}</span>
          @if (remittances) {
            <span class="badge-count">{{ remittances.length }}</span>
          }
        </div>
      </div>
      @if (remittancesError) {
        <div class="load-error"><mat-icon>error_outline</mat-icon><span>Remises de chèques illisibles : {{ remittancesError }}</span></div>
      }
      @if (remittances) {
        <table class="grid remittances">
          <thead>
            <tr>
              <th class="num">N°</th>
              <th>Date</th>
              <th>Banque</th>
              <th>Auteur</th>
              <th>Magasins</th>
              <th class="num">Chèques</th>
              <th class="num">Total</th>
              <th class="c-action"></th>
            </tr>
          </thead>
          <tbody>
            @for (r of remittances; track r.remittance) {
              <tr>
                <td class="num">{{ r.remittance }}</td>
                <td class="c-stamp">{{ stamp(r.dat) }}</td>
                <td class="wrap">{{ r.bank_name ?? ('Banque ' + r.bank) }}</td>
                <td class="wrap">{{ r.user_name }}</td>
                <td class="wrap">{{ r.stores.join(', ') }}</td>
                <td class="num">{{ r.count }}</td>
                <td class="num">{{ r.total | fc }} €</td>
                <td class="c-action">
                  <button mat-icon-button type="button" class="btn-row btn-print-remittance" [attr.aria-label]="'Imprimer la remise n° ' + r.remittance"
                    matTooltip="Imprimer le bordereau de cette remise" (click)="printRemittance(r)">
                    <mat-icon>print</mat-icon>
                  </button>
                  @if (canRemit) {
                    <button mat-icon-button type="button" class="btn-row btn-cancel-remittance" [attr.aria-label]="'Annuler la remise n° ' + r.remittance"
                      matTooltip="Annuler la remise : ses chèques reviennent à remettre" (click)="cancelRemittance(r)">
                      <mat-icon>undo</mat-icon>
                    </button>
                  }
                </td>
              </tr>
            } @empty {
              <tr><td colspan="8" class="empty">Aucune remise de chèques {{ multiDay ? 'sur la période' : 'ce jour' }}</td></tr>
            }
          </tbody>
        </table>
      }
    </div>
    </div>

  </div>

  <!-- Écarts de caisse, repliés : habilitation Responsable RH seule -->
  @if (isHrManager) {
    <app-cash-gaps [store]="store" [day]="lastDay" [stores]="stores" [stations]="stations"></app-cash-gaps>
  }

  <!-- Les règlements, à la suite -->
  <div class="table-card payments-card">
    <div class="table-header-bar">
      <div class="table-title">
        <mat-icon>payments</mat-icon>
        <span>Règlements {{ multiDay ? 'de la période' : 'du jour' }}</span>
        @if (day) {
          <span class="badge-count">{{ countLabel }}</span>
        }
      </div>
      @if (day?.truncated) {
        <span class="truncated"><mat-icon>warning_amber</mat-icon>Liste limitée aux {{ day!.payments.length }} premiers règlements ; les totaux comptent {{ multiDay ? 'toute la période' : 'toute la journée' }}.</span>
      }
      <div class="card-actions">
        <button mat-stroked-button type="button" class="btn-card" id="exportpaymentsbutton" (click)="exportPayments()"
          [disabled]="!day?.payments?.length" matTooltip="Règlements listés en fichier .csv (Excel)">
          <mat-icon>download</mat-icon>
          Exporter
        </button>
        <button mat-stroked-button type="button" class="btn-card" id="printpaymentsbutton" (click)="printPayments()"
          [disabled]="!day?.payments?.length" matTooltip="Journal des règlements filtrés, mis en page par le serveur pour l'impression">
          <mat-icon>print</mat-icon>
          Imprimer
        </button>
        <button mat-stroked-button type="button" class="btn-card" id="printchequesbutton" (click)="openChequeRemittance()"
          [disabled]="!canPrintCheques" matTooltip="Chèques à remettre de la période, du magasin et du poste affichés (comptoir et reprise, pas encore remis) : choix de la banque, remise enregistrée puis bordereau imprimé">
          <mat-icon>receipt_long</mat-icon>
          Remise de chèques
        </button>
      </div>
    </div>
    @if (day) {
      <table class="grid payments">
        <thead>
          <tr>
            <th class="c-hour">Heure</th>
            <th>Magasin</th>
            <th>Poste</th>
            <th>Client</th>
            <th>Pièce(s)</th>
            <th>Mode</th>
            <th>Canal</th>
            <th>Commentaire</th>
            <th class="num">Montant</th>
          </tr>
        </thead>
        <tbody>
          @for (p of day.payments; track p.id) {
            <tr>
              <td class="c-hour">{{ hour(p.dat) }}</td>
              <td>{{ p.store_name }}</td>
              <td>{{ p.station_name }}</td>
              <td class="wrap">{{ p.customer_name }}</td>
              <td class="c-orders">
                @for (o of shownOrders(p); track o; let last = $last) {
                  <a [routerLink]="['/sales/quotation', o]">{{ o }}</a>@if (!last) {, }
                }
                @if (p.order_ids.length > ordersShown) {
                  <button type="button" class="more-orders" [attr.aria-expanded]="ordersExpanded(p.id)" (click)="toggleOrders(p.id)"
                    [matTooltip]="ordersExpanded(p.id) ? 'Réduire la liste des pièces' : 'Afficher les ' + (p.order_ids.length - ordersShown) + ' autres pièces'">
                    {{ ordersExpanded(p.id) ? 'réduire' : '+' + (p.order_ids.length - ordersShown) }}
                  </button>
                }
              </td>
              <td class="c-method">
                <span class="m-name">{{ methodName(p) }}</span>
                @if (p.nature) { <span class="nature">{{ natureLabel(p.nature) }}</span> }
              </td>
              <td>
                @if (channel(p.channel)) { <span class="channel">{{ channel(p.channel) }}</span> }
              </td>
              <td class="c-comment">{{ p.comment }}</td>
              <td class="num" [class.neg]="p.amount < 0">{{ p.amount | fc }} €</td>
            </tr>
          } @empty {
            <tr><td colspan="9" class="empty">Aucun règlement {{ multiDay ? 'sur la période' : 'ce jour' }}</td></tr>
          }
        </tbody>
      </table>
    }
  </div>

</div>
